import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fd93f996")

_pushScopeId("data-v-fd93f996")
const _hoisted_1 = {
  class: "container registration-awaiting",
  id: "registration-awaiting"
}
const _hoisted_2 = { class: "ra-header" }
const _hoisted_3 = { class: "desktop-grid" }
const _hoisted_4 = { class: "w100" }
const _hoisted_5 = { style: {"width":"10%"} }
const _hoisted_6 = { style: {"width":"20%"} }
const _hoisted_7 = { style: {"width":"15%"} }
const _hoisted_8 = { style: {"width":"14%"} }
const _hoisted_9 = { style: {"width":"13%"} }
const _hoisted_10 = { style: {"width":"13%"} }
const _hoisted_11 = /*#__PURE__*/_createVNode("td", {
  class: "desktop-table-action text-end",
  style: {"width":"15%"}
}, null, -1)
const _hoisted_12 = {
  class: "desktop-table-text-setting",
  style: {"width":"10%"}
}
const _hoisted_13 = {
  class: "desktop-table-text-setting",
  style: {"width":"20%"}
}
const _hoisted_14 = { class: "td-ellipsis" }
const _hoisted_15 = {
  class: "desktop-table-text-setting",
  style: {"width":"15%"}
}
const _hoisted_16 = {
  class: "desktop-table-text-setting",
  style: {"width":"14%"}
}
const _hoisted_17 = { class: "td-ellipsis" }
const _hoisted_18 = {
  class: "desktop-table-text-setting",
  style: {"width":"13%"}
}
const _hoisted_19 = { class: "td-ellipsis" }
const _hoisted_20 = {
  class: "desktop-table-text-setting",
  style: {"width":"13%"}
}
const _hoisted_21 = {
  class: "desktop-table-action text-end",
  style: {"width":"15%"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('awaiting.title')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("table", _hoisted_4, [
        _createVNode("thead", null, [
          _createVNode("tr", null, [
            _createVNode("td", _hoisted_5, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('awaiting.id')), 1)
            ]),
            _createVNode("td", _hoisted_6, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('awaiting.fullName')), 1)
            ]),
            _createVNode("td", _hoisted_7, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('awaiting.phoneNumber')), 1)
            ]),
            _createVNode("td", _hoisted_8, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('awaiting.email')), 1)
            ]),
            _createVNode("td", _hoisted_9, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('awaiting.companyName')), 1)
            ]),
            _createVNode("td", _hoisted_10, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('awaiting.createdAt')), 1)
            ]),
            _hoisted_11
          ])
        ]),
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (row, index) => {
            return (_openBlock(), _createBlock("tr", { key: index }, [
              _createVNode("td", _hoisted_12, _toDisplayString(row.id), 1),
              _createVNode("td", _hoisted_13, [
                _createVNode("span", _hoisted_14, _toDisplayString(row.fullName), 1)
              ]),
              _createVNode("td", _hoisted_15, _toDisplayString(row.phoneNumber), 1),
              _createVNode("td", _hoisted_16, [
                _createVNode("span", _hoisted_17, _toDisplayString(row.email), 1)
              ]),
              _createVNode("td", _hoisted_18, [
                _createVNode("span", _hoisted_19, _toDisplayString(row.companyName), 1)
              ]),
              _createVNode("td", _hoisted_20, _toDisplayString(_ctx.getCreatedAt(row.createdAt)), 1),
              _createVNode("td", _hoisted_21, [
                _createVNode("a", {
                  onClick: ($event: any) => (_ctx.ShowLink(row.link)),
                  class: "action-show-link"
                }, "Show Link", 8, ["onClick"])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
})